"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const colors_1 = require("@material-ui/core/colors");
const styles_1 = require("@material-ui/core/styles");
const CheckCircle_1 = __importDefault(require("@material-ui/icons/CheckCircle"));
const Error_1 = __importDefault(require("@material-ui/icons/Error"));
const Info_1 = __importDefault(require("@material-ui/icons/Info"));
const Warning_1 = __importDefault(require("@material-ui/icons/Warning"));
const variantIcon = {
    success: CheckCircle_1.default,
    warning: Warning_1.default,
    error: Error_1.default,
    info: Info_1.default,
};
const useStyles1 = styles_1.makeStyles(theme => ({
    success: {
        backgroundColor: colors_1.green[600],
    },
    error: {
        backgroundColor: theme.palette.error.dark,
    },
    info: {
        backgroundColor: theme.palette.primary.main,
    },
    warning: {
        backgroundColor: colors_1.amber[700],
    },
    icon: {
        fontSize: 20,
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing(1),
    },
    message: {
        display: 'flex',
        alignItems: 'center',
        fontSize: 18,
    },
}));
const MySnackbarContentWrapper = (_a) => {
    var { className, message, variant } = _a, other = __rest(_a, ["className", "message", "variant"]);
    const classes = useStyles1();
    const Icon = variantIcon[variant];
    return (react_1.default.createElement("div", Object.assign({ className: clsx_1.default(classes[variant], className) }, other, { style: { padding: 10, color: 'white', borderRadius: 4, fontSize: 18 } }),
        react_1.default.createElement("span", { id: "client-snackbar", className: classes.message },
            react_1.default.createElement(Icon, { className: clsx_1.default(classes.icon, classes.iconVariant) }),
            message)));
};
exports.default = MySnackbarContentWrapper;
//# sourceMappingURL=index.js.map